import React from 'react';

import get from 'lodash/get';
import orderBy from 'lodash/orderBy';
import PropTypes from 'prop-types';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


import ApiError from '@src/components/common/Errors/ApiError';
import { TrainingsRow } from '@src/components/trainings/TrainingsList';
import { Loader } from '@src/components/ui';
import { useJobAidsQuery } from '@src/hooks/queries/jobAids';
import { useTrainingsQuery } from '@src/hooks/queries/trainings';

const addJobAidUrlPrefix = (item) => ({
    ...item,
    urlPrefix: 'training-and-job-aids/job-aids',
});

const addTrainingUrlPrefix = (item) => ({
    ...item,
    urlPrefix: 'training-and-job-aids/elearnings',
});

const FeaturedTrainingsAndJobAids = (props) => {
    const { searchString } = props;

    const {
        isIdle: jIdle,
        isLoading: jIsLoading,
        isError: jIsError,
        error: jError,
        data: jData,
    } = useJobAidsQuery(searchString);

    const {
        isIdle: tIdle,
        isLoading: tIsLoading,
        isError: tIsError,
        error: tError,
        data: tData,
    } = useTrainingsQuery(searchString);

    const isError = jIsError || tIsError;

    const isIdle = jIdle || tIdle;

    const isLoading = jIsLoading || tIsLoading;

    const data = React.useMemo(() => {
        if (isLoading) {
            return [];
        }

        const jobAids = get(jData, 'job_aids').map(addJobAidUrlPrefix);
        const trainings = get(tData, 'trainings').map(addTrainingUrlPrefix);

        return orderBy(jobAids.concat(trainings), 'updated_at', 'desc').slice(0, 4);
    }, [isLoading, jData, tData]);

    if (isIdle) {
        return null;
    }

    if (isLoading) {
        return <Loader />;
    }

    if (isError) {
        const thisError = jError || tError;
        return <ApiError error={thisError} />;
    }

    if (data.length === 0) {
        return (
            <Row>
                <Col>
                    <p className="text-center">No Results</p>
                </Col>
            </Row>
        );
    }

    return (
        <TrainingsRow trainings={data} />
    );
};

FeaturedTrainingsAndJobAids.propTypes = {
    searchString: PropTypes.string,
};

export default React.memo(FeaturedTrainingsAndJobAids);
